import { get, post, deleteRequest, patch } from 'utils/api';

export const getUsers = (data) => {
  return get(`/users`, data);
};

export const getUserById = (id) => {
  return get(`/users/${id}`);
};

export const getRoles = (data) => {
  return get(`/roles`, data);
};

export const addUser = (data) => {
  return post(`/users`, data);
};

export const deleteUser = (id) => {
  return deleteRequest(`/users/${id}`);
};

export const updateUser = (data) => {
  const userId = data.id;
  delete data['id'];
  return patch(`/users/${userId}`, data);
};

export const getFleetMembers = (data) => {
  const id = data.id;
  delete data['id'];
  return get(`/users/getfleetmembers/${id}`, data);
};

export const user = {
  getUsers,
  getUserById,
  getRoles,
  addUser,
  deleteUser,
  updateUser,
  getFleetMembers,
};
